import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchEzdsApi,
  filterEzdApi,
  fetchEzdsByIdAPI,
  addEzdBranchAPI,
  getEzdBranchByIdAPI,
  editEzdBranchAPI,
} from "../../../api/endpoint";

function* getEzdInfoSaga(action) {
  try {
    const _api = yield call(fetchEzdsApi, action.payload);
    yield put(actions.setEzdInfo(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* getEzdById(action) {
  try {
    const _api = yield call(fetchEzdsByIdAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setEzdById(_api.data.results));
      yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);
  }
}

function* filterEZDSaga(action) {
  try {
    const _api = yield call(filterEzdApi, action.payload);
    yield put(actions.setFilteredEzd(_api.data.results));
    yield put(commonActions.setLoading(false));
    yield put(commonActions.setClearFilter(true));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* addEzdBranchSaga(action) {
  try {
    const _api = yield call(addEzdBranchAPI, action.payload);
    yield put(commonActions.setLoading(false));
    yield put(commonActions.setRedirect(true));
  } catch (error) {
    console.error(error);
    if (error.message === "Request failed with status code 422") {
      yield put(commonActions.setError(true));
      yield put(commonActions.setErrorMessage("Branch code already exists"));
      yield put(commonActions.setLoading(false));
    }
  }
}

function* getBranchByIdSaga(action) {
  try {
    const _api = yield call(getEzdBranchByIdAPI, action.payload);
    yield put(actions.setBranchById(..._api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.error(error);
  }
}

function* editEzdBranchSaga(action) {
  try {
    const _api = yield call(editEzdBranchAPI, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(commonActions.setRedirect(true));
    }
  } catch (error) {
    console.error(error);
    yield put(commonActions.setLoading(false));
  }
}

export function* watchEzdInfoSaga() {
  yield all([
    takeEvery(actionTypes.GET_EZD_INFO, getEzdInfoSaga),
    takeEvery(actionTypes.GET_FILTERED_EZD, filterEZDSaga),
    takeEvery(actionTypes.GET_EZD_BY_ID, getEzdById),
    takeEvery(actionTypes.ADD_EZD_BRANCH, addEzdBranchSaga),
    takeEvery(actionTypes.GET_BRANCH_BY_ID, getBranchByIdSaga),
    takeEvery(actionTypes.EDIT_EZD_BRANCH, editEzdBranchSaga),
  ]);
}
